<form class="w-100 h-100 form" [formGroup]="blogSectionForm" (ngSubmit)="sendData()">
  <h4 class="text-center">{{sectionInfo.sectionId ? 'Editar Categoría' : 'Crear Categoría'}}</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nombre de categoría</mat-label>
        <input matInput placeholder="Nombre de sección" formControlName="name">
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
  </div>


  <button class="vs-btn-blue" type="submit" [disabled]="blogSectionForm.invalid">
    Guardar
  </button>

</form>

